module.exports = __webpack_public_path__ + "img/money-bill-alt.943b50d6.svg";